module.exports = __webpack_public_path__ + "static/media/fm.dc5fbf1d.svg";